import React from "react";
import MetropolitanPlanningTrafficEngineering from "../../asset/Directorates/outer/Metropolitan Planning & Traffic Engineering.png";
import LandDevelopment from "../../asset/Directorates/outer/Land Development.png";
import Engineering from "../../asset/Directorates/outer/Engineering.png";
import Finance from "../../asset/Directorates/outer/Finance.png";
import Administration from "../../asset/Directorates/outer/Administration.png";
import LandBuildingControl from "../../asset/Directorates/outer/Land Use & Building Control.png";
import EstateManagement from "../../asset/Directorates/outer/Estate Management.png";
import Architecture from "../../asset/Directorates/outer/Architecture.png";
import ITWing from "../../asset/Directorates/outer/IT Wing.png";
import PRWing from "../../asset/Directorates/outer/PR Wing.png";

import { NavLink } from "react-router-dom";
import { GoArrowUpRight } from "react-icons/go";

const Directorates = () => {
  const directoratesCard = [
    {
      name: "Administration Directorate",
      image: Administration,
      link: "/administration",
    },
    {
      name: "Finance Directorate",
      image: Finance,
      link: "/finance",
    },
    {
      name: "Engineering Directorate",
      image: Engineering,
      link: "/engineering",
    },

    {
      name: "Land Development Directorate",
      image: LandDevelopment,
      link: "/land-development-estate-management",
    },
    {
      name: "Estate Management Directorate",
      image: EstateManagement,
      link: "/estate-management",
    },
    {
      name: "Metropolitan Planning & Traffic Engineering Directorate",
      image: MetropolitanPlanningTrafficEngineering,
      link: "/metropolitan-planning-traffic-engineering",
    },
    {
      name: "Land Use & Building Control Directorate",
      image: LandBuildingControl,
      link: "/land-building-control",
    },
    {
      name: "Architecture Directorate",
      image: Architecture,
      link: "/architecture",
    },
    {
      name: "IT Wing",
      image: ITWing,
      link: "/IT-wing",
    },
    {
      name: "PR Wing",
      image: PRWing,
      link: "/PR-wing",
    },
  ];
  return (
    <div className="flex flex-col gap-10 lg:py-20 py-10 xl:px-[5%] lg:px-[3%] md:px-[3%] px-[6%] bg-white md:bg-[#F6F6F6] ">
      <div className="w-full">
        <h1 className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem] text-[2rem] md:text-left text-center font-semibold">
          Directorates
        </h1>
        <p className="w-[100%] md:text-left text-center xl:text-[1.3rem] lg:text-[1rem] md:text-[.9rem] text-[1rem] ">
          The Rawalpindi Development Authority (RDA) is responsible for
          planning, development, and infrastructure in Rawalpindi. It has
          several directorates that handle different aspects of urban
          development and administration.
        </p>
      </div>
      <div className="grid 2xl:grid-cols-5 xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1   gap-4">
        {directoratesCard.map((card, i) => (
          <NavLink to={`${card.link}`} key={i} className=" w-full  relative">
            <img src={card?.image} className="rounded-xl w-full" alt="" />
            <div className="w-full h-full top-0 rounded-xl bg-gradient-to-t from-[#00643B] to-transparent absolute z-10 "></div>
            <div className=" absolute bottom-5 bg-white rounded-lg z-20 w-[95%] mx-[2.5%] p-2 ">
              <div className="flex justify-between items-center lg:text-[1rem] md:text-[.9rem] text-[.75rem] font-semibold">
                <span>{card.name}</span>
                <NavLink to={`${card.link}`}>
                  <GoArrowUpRight className="size-8 p-1 rounded-full cursor-pointer font-bold bg-[#00643b] text-white" />
                </NavLink>
              </div>
            </div>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default Directorates;
